import { CashType } from '../../redux/data/dataTypes';
import api from '../axios/axiosInstance';

export type CashTypeFrom = CashType;

const createCash = async (data: CashTypeFrom): Promise<any> => {
  return api.post('/cash-transactions', data);
};

export { createCash };
